import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BdbSessionStrgService} from '@npm-bbta/bbog-cm-auth-lib';
import {environment} from '../../../environments/environment';
import {MantizRequestModel} from '../models/mantizRequest.model';
import {ICandidateInfoModel} from '../models/candidate-info.model';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';

@Injectable()
export class MantizService {
    constructor(private httpClient: HttpClient,
                private bdbSessionStrgService: BdbSessionStrgService) {}

    public async getUrlMantiz(): Promise<any> {
        let bodyRequest: MantizRequestModel;

        bodyRequest = {
            NetUser: this.bdbSessionStrgService.get('sellerUsername') || '',
            Identificacion: this.bdbSessionStrgService.get('identityNumber'),
            TipoIdentificacion: this.bdbSessionStrgService.get('identityType')
        };

        if (this.bdbSessionStrgService.get(SessionStorageKeysEnum.CANDIDATE)) {
            const infoCandidate = this.bdbSessionStrgService.get(SessionStorageKeysEnum.CANDIDATE);
            const candidate = JSON.parse(infoCandidate) as ICandidateInfoModel;
            bodyRequest.PrimerNombre = candidate.primerNombre || '';
            bodyRequest.PrimerApellido = candidate.primerApellido || '';
            bodyRequest.SegundoNombre = candidate.segundoNombre || '';
            bodyRequest.SegundoApellido = candidate.segundoApellido || '';
        }
        const headers = {
            'Content-type': 'application/json',
            'X-Channel': this.bdbSessionStrgService.get(SessionStorageKeysEnum.MEDIUM_TYPE) || '',
            'X-IPAddr': this.bdbSessionStrgService.get(SessionStorageKeysEnum.PUBLIC_IP) || '',
            'X-Product': this.bdbSessionStrgService.get(SessionStorageKeysEnum.SITE) || '',
            'X-RqUID': this.bdbSessionStrgService.get('uuid') || '',
        };
        console.log('data body for mantiz', bodyRequest);
        try {
            const url = `${environment.authenticatorV2Endpoint}/mantiz/getUrlBiometric`;
            return await this.httpClient.post(url, bodyRequest, {headers}).toPromise()
        }catch (e) {
            return Promise.reject(null);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/mantiz.service.ts